import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Typography } from '@/js/libs/ui';
import { Button, CopyTooltip as CopyTooltipUI, Icons } from '@/js/libs/ui/src/V2';
import { copy } from '@/js/libs/utils/copy';

interface CopyTooltipProps {
  title?: string;
  value: string;
  header?: boolean;
  dataTestId?: string;
}

export const CopyTooltip = React.memo(function CopyTooltip({ title, value, header, dataTestId }: CopyTooltipProps) {
  const [t] = useTranslation(['backend', 'common']);
  const { colors } = useTheme();

  const handleCopyId = useCallbackRef(() => copy(value));

  return (
    <CopyTooltipUI tooltip={t('common:COPY')} onClick={handleCopyId} copiedTooltip={t('common:COPIED')} data-testid='copied-tooltip'>
      <Button ghost reducedGap>
        <Icons.Copy color={header ? colors.grey100_1 : undefined} />
        {header ? (
          <Typography.TextMedium color={colors.grey100_1} children={title ?? value} data-testid={`${dataTestId}-title`} />
        ) : (
          (title ?? value)
        )}
      </Button>
    </CopyTooltipUI>
  );
});
